// Only navigate to a video's own public platform route. Never proxy media here.
const PLATFORM_NAMES = { instagram: "Instagram", tiktok: "TikTok", youtube: "YouTube" };
const CONTROLS = /[\u0000-\u001f\u007f\\]/;

// Comparison rows omit url/source; their enclosing creator retains provenance.
export const isDemoMedia = (video, creator) => {
  const source = video?.source ?? creator?.source;
  return source === "demo"
    || (source !== "live" && !(typeof video?.url === "string" && video.url.trim()));
};

// Reduced projections without url/source stay neutral: only an explicit Demo source is trusted.
export const explicitDemoMedia = (item) => item?.source === "demo";

export function imageSource(value) {
  if (typeof value !== "string" || CONTROLS.test(value)) return null;
  const source = value.trim();
  if (!source) return null;
  if (source.startsWith("/") && !source.startsWith("//")) return source;
  try {
    const url = new URL(source);
    return url.protocol === "https:" && !url.username && !url.password && !url.port ? url.href : null;
  } catch {
    return null;
  }
}

export function originalVideoLink(video) {
  if (video?.source === "demo" || typeof video?.url !== "string" || CONTROLS.test(video.url)) return null;
  let url;
  try { url = new URL(video.url.trim()); } catch { return null; }
  if (url.protocol !== "https:" || url.username || url.password || url.port) return null;

  const host = url.hostname;
  let path = url.pathname;
  if (video.platform === "instagram") {
    if (!["instagram.com", "www.instagram.com"].includes(host)
        || !/^\/(?:p|reel|reels)\/[A-Za-z0-9_-]+\/?$/.test(path)) return null;
  } else if (video.platform === "tiktok") {
    if (!["tiktok.com", "www.tiktok.com"].includes(host)
        || !/^\/@[A-Za-z0-9_.]+\/video\/\d+\/?$/.test(path)) return null;
  } else if (video.platform === "youtube") {
    if (host === "youtu.be") {
      if (!/^\/[A-Za-z0-9_-]{11}\/?$/.test(path)) return null;
    } else {
      if (!["youtube.com", "www.youtube.com", "m.youtube.com"].includes(host)) return null;
      if (path === "/watch") {
        const ids = url.searchParams.getAll("v");
        if (ids.length !== 1 || !/^[A-Za-z0-9_-]{11}$/.test(ids[0])) return null;
        path += `?v=${ids[0]}`;
      } else if (!/^\/shorts\/[A-Za-z0-9_-]{11}\/?$/.test(path)) return null;
    }
  } else {
    return null;
  }
  return { href: `${url.origin}${path}`, label: `Ouvrir sur ${PLATFORM_NAMES[video.platform]}` };
}
